import { render, staticRenderFns } from "./BIT.vue?vue&type=template&id=5142d01a&"
import script from "./BIT.vue?vue&type=script&lang=js&"
export * from "./BIT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5142d01a')) {
      api.createRecord('5142d01a', component.options)
    } else {
      api.reload('5142d01a', component.options)
    }
    module.hot.accept("./BIT.vue?vue&type=template&id=5142d01a&", function () {
      api.rerender('5142d01a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/BIT.vue"
export default component.exports